import { Box, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import Banner from "../../assets/Banner.png";

const RecentPosts = ({ posts }) => {
  const navigate = useNavigate();

  const extractImageFromContent = (htmlContent = "") => {
    const match = htmlContent.match(/<img.*?src=["'](.*?)["']/);
    return match ? match[1] : null;
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ color: "#ffd700", fontWeight: "bold", fontStyle: "italic" }}
      >
        Recent Posts
      </Typography>

      {posts.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No posts posted.
        </Typography>
      ) : (
        [...posts]
          .sort((a, b) => {
            const da = new Date(a.externalPublishedAt || a.createdAt).getTime();
            const db = new Date(b.externalPublishedAt || b.createdAt).getTime();
            return db - da;
          })
          .slice(0, 3)
          .map((post, i) => {
            const isExternalNews = post.type === "news" && post.isExternal;

            const image =
              post.type === "blog"
                ? post.imageUrl ||
                  extractImageFromContent(post.content || "") ||
                  Banner
                : post.imageUrl || null;

            const displayDate = post.externalPublishedAt || post.createdAt;

            const viewHref = isExternalNews
              ? post.externalUrl
              : `/blogs/${post._id}`;
            const viewTarget = isExternalNews ? "_blank" : "_self";

            const handleCardClick = () => {
              if (post.type === "news") {
                if (isExternalNews && post.externalUrl) {
                  window.open(
                    post.externalUrl,
                    "_blank",
                    "noopener,noreferrer"
                  );
                } else {
                  navigate(`/blogs/${post._id}`);
                }
                return;
              }

              navigate(`/blogs/${post._id}`);
            };

            return (
              <Box
                key={post._id || i}
                onClick={handleCardClick}
                sx={{
                  mb: 0,
                  cursor: "pointer",
                  pb: 2,
                  borderBottom: "1px solid #eee",
                }}
              >
                <Box sx={{ display: "flex", gap: 2, p: 1 }}>
                  {image && (
                    <Box
                      component="img"
                      src={image}
                      alt="post preview"
                      sx={{
                        width: 60,
                        height: 60,
                        objectFit: "cover",
                        borderRadius: 1,
                        flexShrink: 0,
                      }}
                    />
                  )}

                  <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                        {displayDate
                          ? new Date(displayDate).toLocaleDateString()
                          : ""}
                      </Typography>

                      {i === 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#ffd700",
                            color: "#fff",
                            borderRadius: "12px",
                            px: 1,
                            py: 0.3,
                            ml: 1,
                            fontSize: "0.75rem",
                            animation: "blink 1.5s infinite",
                            "@keyframes blink": {
                              "0%, 100%": { opacity: 1 },
                              "50%": { opacity: 0.2 },
                            },
                          }}
                        >
                          <AutoAwesomeOutlinedIcon
                            sx={{ fontSize: "0.75rem", mr: 0.5 }}
                          />
                          New
                        </Box>
                      )}
                    </Box>

                    <Typography
                      variant="body2"
                      sx={{
                        mb: 0.5,
                        "&:hover": {
                          color: "primary.main",
                        },
                      }}
                    >
                      {post.title}
                    </Typography>

                    <Link
                      href={viewHref}
                      target={viewTarget}
                      rel={isExternalNews ? "noopener noreferrer" : undefined}
                      sx={{ fontSize: "12px" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      View
                    </Link>
                  </Box>
                </Box>
              </Box>
            );
          })
      )}
    </Box>
  );
};

export default RecentPosts;
